module.exports = __webpack_public_path__ + "img/recommend.d101c116.png";